import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTabItem,[(_vm.tab.groupings)?_c(VCard,{staticClass:"mt-1 py-8 employee-details__groups",attrs:{"flat":""}},[_c(VCardText,[_c(VRow,_vm._l((_vm.tab.groupings),function(grouping){return _c(VCol,{key:grouping.id},[_c('details-grouping',{attrs:{"grouping":grouping,"readonly":_vm.readonly},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}),1)],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }